(function () {

    'use strict';

    angular.module('iplusjs.tag', [
        'lodash'
    ])
    .component('iplusjsTag', {
        bindings: {
            tag: '<itTag',
            isNavigatable: '<itNavigatable',
            disabled: '<itDisabled',
            onClose: '&itOnClose'
        },
        templateUrl: 'common/tag/tag.html',
        controller: TagController,
        controllerAs: 'tagVm'
    });

    TagController.$inject = [
        'lodash'
    ];
    function TagController(_) {
        var vm = this,
            keyCodes = {
                ENTER: 13
            };

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.onClick = onClick;
        vm.onKeydown = onKeydown;

        function activate() {
            vm.isNavigatable = _.isBoolean(vm.isNavigatable) ? vm.isNavigatable : true;
        }

        function onInit() {
            activate();
        }

        function onChanges() {
            activate();
        }

        function onClick(tag) {
            close(tag);
        }

        function onKeydown(event, tag) {
            if (event && event.keyCode === keyCodes.ENTER) {
                event.preventDefault();

                close(tag);
            }
        }

        function close(tag) {
            if (vm.disabled) {
                return;
            }

            vm.onClose({
                tag: tag
            });
        }

    }
})();
